<rt-dropdown (click)="$event.preventDefault()">
  <rt-dropdown-header [hasDivider]="false">
    {{ 'rtu.interview.schedule_dialog.timezone' | translate }}
  </rt-dropdown-header>
  <rt-time-zone-picker-dropdown-list [dark]="true" (zoneSelect)="zoneSelect.emit($event)">
  </rt-time-zone-picker-dropdown-list>
</rt-dropdown>
